
import * as ipxRuntime$_DHmILeX2B2sk77bVJ9JF9uY1M4DYS7_qtC26niLSnA from '/build/e0e5e7ed-821e-4037-840b-5c5c6f0cb639/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$_DHmILeX2B2sk77bVJ9JF9uY1M4DYS7_qtC26niLSnA, defaults: {} }
}
        